const incrementos = [
    {
        img: "brigadeiro-de-colher.jpg",
        name: "Pasta de Amendoim 650g - Dr.Peanut",
        price: 62.38,
        parcelas: 2,
        type: "other",
        promo: false,
    },
    {
        img: "chocolate_avela.jpg",
        name: "Calda de Chocolate e Avelã 335g - Mrs Taste",
        price: 31.99,
        parcelas: 2,
        type: "other",
        promo: false,
    },
    {
        img: "Barbecue.jpg",
        name: "Molho Barbecue 350g - Mrs Taste",
        price: 31.99,
        parcelas: 2,
        type: "other",
        promo: false,
    },
    {
        img: "power1.jpg",
        name: "Pasta de Amendoim 1,005kg - Power One ",
        price: 20.49,
        parcelas: 2,
        type: "other",
        promo: true,
    },
    {
        img: "Cd_Chocolate.jpg",
        name: "Calda de Chocolate 335g - Mrs Taste ",
        price: 31.99,
        parcelas: 2,
        type: "other",
        promo: false,
    },
    {
        img: "dc_leite_Mrs_Taste.jpg",
        name: "Calda de Doce de Leite 335g - Mrs Taste ",
        price: 31.99,
        parcelas: 2,
        type: "other",
        promo: false,
    },
]

export default incrementos;